import { createContext } from 'react';
import { PraksisaktivitetDto as UHAPraksisaktivitetDto } from '../api/generated/studiested-generated-api';
import { PraksisaktivitetDto as PSAPraksisaktivitetDto } from '../api/generated/praksissted-generated-api';
import useContextNotUndefined from '../hooks/useContextNotUndefined';

export type ActivityContextUHAType = {
  praksisaktivitet: UHAPraksisaktivitetDto;
  reloadPraksisaktivitet: () => void;
};

/**
 * IMPORTANT: ActivityContextUHA should only be used as a provider,
 * when praksisaktivitet is not undefined. It will throw an error
 * otherwise. It should not be used directly as a Consumer, and
 * rather be used by the custom hook useActivityContextUHA.
 * */
export const ActivityContextUHA = createContext<
  ActivityContextUHAType | undefined
>(undefined);

export const useActivityContextUHA = () =>
  useContextNotUndefined(ActivityContextUHA, 'useActivityContextUHA');

export type ActivityContextPSAType = {
  praksisaktivitet: PSAPraksisaktivitetDto;
  reloadPraksisaktivitet: () => void;
};

/**
 * IMPORTANT: ActivityContextPSA should only be used as a provider,
 * when praksisaktivitet is not undefined. It will throw an error
 * otherwise. It should not be used directly as a Consumer, and
 * rather be used by the custom hook useActivityContextPSA.
 * */
export const ActivityContextPSA = createContext<
  ActivityContextPSAType | undefined
>(undefined);

export const useActivityContextPSA = () =>
  useContextNotUndefined(ActivityContextPSA, 'useActivityContextPSA');
